import TenantService from './tenant.service';
export default TenantService;